import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as i18next from 'i18next';
import * as api from 'core/api';
import moment from 'moment';
import * as utils from 'core/utils';
import * as flights from 'core/flights';
import * as payment from 'core/payment';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

export function requiredIfCard(value) {
    if (this.paymentModel.selectedPaymentType.kind === 'CreditCardInplace'
        && !value
        && !this.paymentModel.selectedPaymentType.isYandexPay)
    {
        return false;
    }
    return true;
}

export function cardCode(value) {
    if (value) {
        const card = new utils.Card(this.paymentModel.card.number, value);

        if (!card.cvcIsValid) {
            return false;
        }
    }
    return true;
}

export function cardNumber(value) {
    if (value) {
        const card = new utils.Card(value, this.paymentModel.card.code);

        if (!card.numberIsValid) {
            return false;
        }
    }
    return true;
}

export function cardExpired(value) {
    if (value
        && moment(value).isBefore(moment())) {
        return false;
    }
    return true;
}

@WithRender
@Component({
    validations: {
        paymentModel: {
            card: {
                holder: { requiredIfCard },
                number: { requiredIfCard, cardNumber },
                expiry: { requiredIfCard },
                code: { requiredIfCard, cardCode }
            }
        }
    }
})
export class PaymentFormComponent extends Vue {
    @Prop()
    amount: number;

    @Prop()
    gaAlreadySubmitted: string[];

    @Prop()
    paymentModel: payment.PaymentModel;

    @Prop()
    reservation: flights.ReservationModel;

    @Prop()
    flight: flights.FlightModel;

    @Prop()
    showSbp: boolean;

    parceladoState: string = '';

    flagSmsPackage: number = 0;

    get moneyWallPrice() {
        if (this.flight) {
            return utils.Payment.calcMoneyWallPrice(this.amount, this.flight.legs[0].segments[0].departureDate);
        }
        return 0;
    }

    get yandexSmsProduct() {
        return this.reservation ? this.reservation.productsOfYandex.find(item => item.product.externalId = 'MegoPackageSuperSms') : null;
    }

    @Watch('paymentModel.selectedPaymentTab')
    onPaymentTabChange(value: string) {
        // @Todo Удалить или отрефакторить yandex код
        let yandexPaySms, bookingSms;

        if (value == 'parcelado') {
            this.parceladoState = 'loading';
            this.onParceladoSelect();
            (<any>this).$ga.sendEvent('flights.booking', 'step3.payment.installment', 'flights.booking.step3.payment.installment');
        }

        if (this.reservation?.products) {
            yandexPaySms = this.reservation.products.find(item => item.product.externalId == 'MegoPackageSuperSms' && item.product.saleType == 'YandexPayButton');
            bookingSms = this.reservation.products.find(item => item.product.externalId == 'MegoPackageSuperSms' && item.product.saleType == 'BookingForm');
        }

        if (yandexPaySms) {
            value == 'yandexpay' ? yandexPaySms!.selected = true : yandexPaySms!.selected = false;
        }

        if (this.yandexSmsProduct && value == 'yandexpay' && bookingSms?.selected == true) {
            bookingSms!.selected = false;
            this.onProductSelectionChange(this.yandexSmsProduct, value === 'yandexpay');
            this.flagSmsPackage = 1;
        } else if (this.yandexSmsProduct) {
            this.onProductSelectionChange(this.yandexSmsProduct!, value === 'yandexpay');
        }

        if (yandexPaySms && bookingSms) {
            if (this.flagSmsPackage == 1 && !this.yandexSmsProduct!.selected) {
                bookingSms!.selected = true;
            }
        }

        this.paymentModel.onSelectedPaymentTabChanged();
        const selectedPayment = this.paymentModel.selectedPaymentType;
        const selectedPaymentMethod = value === 'yandexpay' ?  this.paymentModel.selectedPaymentMethod : '';

        if (!this.gaAlreadySubmitted.includes('flights.booking.payment.changed') && value) {
            (<any>this).$ga.sendEvent(
                'flights.booking',
                'payment.changed',
                'flights.booking.payment.changed'
            );
            this.gaAlreadySubmitted.push('flights.booking.payment.changed');
        }

        if (value) {
            (<any>this).$ga.sendEvent(
                'flights.booking',
                `payment.${selectedPayment.kind}.${selectedPayment.paymentTypeId}.${selectedPaymentMethod ? selectedPaymentMethod.type + '.' : ''}selected`.toLowerCase(),
                `flights.booking.${selectedPayment.kind}.${selectedPayment.paymentTypeId}.${selectedPaymentMethod ? selectedPaymentMethod.type + '.' : ''}selected`.toLowerCase()
            );
        }
    }

    selectPaymentTab(tab: string){
        this.paymentModel.selectedPaymentTab = tab;
    }

    showMoreDetails(type: string) {
        const selectedPayment = this.paymentModel.selectedPaymentType;
        const selectedPaymentMethod = type === 'yandexpay' ? this.paymentModel.selectedPaymentMethod : '';

        (<any>this).$ga.sendEvent(
            'flights.booking',
            `payment.${selectedPayment.kind}.${selectedPayment.paymentTypeId}.${selectedPaymentMethod ? selectedPaymentMethod.type + '.' : ''}details`.toLowerCase(),
            `flights.booking.${selectedPayment.kind}.${selectedPayment.paymentTypeId}.${selectedPaymentMethod ? selectedPaymentMethod.type + '.' : ''}details`.toLowerCase()
        );
    }

    getCommissionLabel(v: number): string {
        return i18next.t('label_payment_commission_withvalue', <any>{ i: (<any>this.$options.filters).price(v) });
    }

    getMonthlyPaymentLabel(): number {
        return this.reservation.getTotalPrice() / 6;
    }

    /**
     * Return error or null if credit card form valid.
     */
    validate(): string | null {
        if (this.paymentModel.selectedPaymentType.kind === 'CreditCardInplace' && !this.paymentModel.selectedPaymentType.isYandexPay) {
            this.$v.paymentModel!.card!.$touch();

            if (this.$v.paymentModel!.card!.$error) {
                let error = null;

                if (!error && !this.$v.paymentModel!.card!.number!.cardNumber) {
                    error = i18next.t('error_card_number_wrong');
                }

                // if (!error && !this.$v.paymentModel!.card!.expiry!.cardExpired) {
                //     error = i18next.t('error_card_expiry_wrong');
                // }

                if (!error && !this.$v.paymentModel!.card!.code!.cardCode) {
                    error = i18next.t('error_card_code_wrong');
                }

                if (!error) {
                    error = i18next.t('error_fields');
                }

                return error;
            }
        }

        return null;
    }

    onCardNumberInput() {
        this.$emit('card-number-input');
    }

    onProductSelectionChange(product: flights.ProductModel, value: boolean) {
        this.$emit('product-selection-change', product, value);
    }

    onParceladoSelect(){
        setTimeout(()=>{
            this.parceladoState = '';
        }, 2750);
    }

    openSbpFaq() {
        window.open('https://sbp.nspk.ru/faq/', '_blank');
    }
}
